import * as c from "../../constants/outputs";
import { ENG_INIT } from "../../constants/engineering";

export const defaultState = {
  toolbar: [],
  selectedUrl: ""
};

const outputs = (state = defaultState, action) => {
  switch (action.type) {
    case ENG_INIT:
      return { ...state, toolbar: action.data.outputs.toolbar };
    case c.OUTPUTS_SELECT_URL:
      return { ...state, selectedUrl: action.url };
    default:
      return state;
  }
};

export default outputs;
